import * as ReactNative from 'react-native-web';
import PropTypes from 'prop-types';
import React from 'react';
import mapDataProps from './utils/mapDataProps';

ReactNative.Text.propTypes = { style: PropTypes.any };
ReactNative.View.propTypes = { style: PropTypes.any };
ReactNative.Image.propTypes = { style: PropTypes.any };

const originalCreateElement = React.createElement;
React.createElement = (type, props, ...children) => originalCreateElement(type, mapDataProps(type, props), ...children);
